import { render, staticRenderFns } from "./PreviousOrders.vue?vue&type=template&id=f4583f8c"
import script from "./PreviousOrders.vue?vue&type=script&lang=js"
export * from "./PreviousOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VAlert,
  VAutocomplete,
  VBtn,
  VCard,
  VDataTable,
  VDatePicker,
  VFlex,
  VForm,
  VIcon,
  VLayout,
  VMenu,
  VProgressLinear,
  VTextField,
})
